export default {
  'zh-CN': {
    i18n: '多语言'
  },
  'en-US': {
    i18n: 'Internationalization'
  }
};